<div class="homeBody">
  <div class="fullBodyImgHome"></div>
  <div class="container">
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
      <div class="card border-0 shadow rounded-3 my-5">
        <div class="card-body p-4 p-sm-5">
          <h5 class="card-title text-center mb-5 fw-light fs-5">
            Ingreso al Sistema
          </h5>
          <form [formGroup]="formLogin" (submit)="login()">
            <div class="form-floating mb-3">
              <input
                type="text"
                pInputText
                class="form-control"
                id="floatingInput"
                formControlName="user"
                placeholder="Usuario"
              />
              @if ( formLogin.get('user')?.invalid &&
              formLogin.get('user')?.dirty) {
              <small class="p-error block"> El usuario es requerido</small>
              }
              <label for="floatingInput">Usuario</label>
            </div>
            <div class="form-floating mb-3">
              <input
                type="password"
                pInputText
                class="form-control"
                id="floatingPassword"
                formControlName="password"
                placeholder="Contraseña"
              />
              <label for="floatingPassword">Contraseña</label>
              @if ( formLogin.get('password')?.invalid &&
              formLogin.get('password')?.dirty) {
              <small class="p-error block"> El password es requerido</small>
              }
            </div>
            <div class="d-grid">
              <button
                pButton
                type="submit"
                label="Submit"
                [disabled]="formLogin.invalid"
                class="btn btn-primary btn-login text-uppercase fw-bold"
              ></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
